// import { cloneDeep } from 'lodash'

export default {
  /* coreToolbarActionsHide(state, actionsHidden) {
    Object.keys(state.coreToolbar.actionsShow).forEach(
      action => (state.coreToolbar.actionsShow[action] = true),
    )
    actionsHidden.forEach(action => (state.coreToolbar.actionsShow[action] = false))
    // Object.entries(actions).forEach((action, status) => {
    //   state.coreToolbar.actions[action] = status
    // })
  }, */
  nodeCurrentSet(state, node) {
    const nodeLevelEmpty = {
      id: '',
      title: '',
    }
    state.nodeCurrent.workspace = 'workspace' in node ? node.workspace : nodeLevelEmpty
    state.nodeCurrent.master = 'master' in node ? node.master : nodeLevelEmpty
    state.nodeCurrent.instance = 'instance' in node ? node.instance : nodeLevelEmpty
  },
  /* coreToolbarBreadcrumbsSet(state, breadcrumbsActive) {
    state.coreToolbar.breadcrumbs = breadcrumbsActive
  }, */
  /* coreToolbarTitleSetText(state, titleText) {
    state.coreToolbar.title.type = 'text'
    state.coreToolbar.title.text = titleText
  },
  coreToolbarTitleSetMenu(state, workspaceCurrent) {
    state.coreToolbar.title.type = 'menu'
    state.coreToolbar.title.text = workspaceCurrent
  }, */
  toastSet(state, alert) {
    state.toast.show = true
    state.toast.message = alert.message
    state.toast.color = alert.color
  },
  errorDataUnauthorizedAccessSet(state, booleanValue) {
    state.errorDataUnauthorizedAccess = booleanValue
  },
  errorDataMissingSet(state, booleanValue) {
    state.errorDataMissing = booleanValue
  },
  errorsDataAccessAllSetFalse(state) {
    state.errorDataUnauthorizedAccess = false
    state.errorDataMissing = false
  },
  userLoggedIn(state, user) {
    state.userLogged.logged = true
    Object.keys(user).forEach(property => (state.userLogged[property] = user[property]))
  },
  userLoggedOut(state) {
    state.userLogged.logged = false
    state.userLogged.token = null
  },
}
